// REPORT ACTIONS

export const CREATE_MOBILITY_REPORT = 'CREATE_MOBILITY_REPORT'
export const REPORT_ERROR = 'REPORT_ERROR'

// PROJECT ACTIONS

export const FETCH_PROJECT_BY_ID = 'FETCH_PROJECT_BY_ID'

// AREAS ACTIONS

export const CREATE_AREA = 'CREATE_AREA'
export const FETCH_AREAS = 'FETCH_AREAS'
export const TAKE_AREA = 'TAKE_AREA'
export const DELETE_AREA_AND_REFETCH = 'DELETE_AREA_AND_REFETCH'
export const DELETE_AREA = 'DELETE_AREA'
export const SHOW_ERR = 'SHOW_ERR'

// GUIDE ACTIONS

export const ENABLE_GUIDE = 'ENABLE_GUIDE'
export const DISABLE_GUIDE = 'DISABLE_GUIDE'
export const SET_CURRENT_GUIDE = 'SET_CURRENT_GUIDE'
export const SET_GUIDE_STEP = 'SET_GUIDE_STEP'

// TEMP ACTIONS

export const CREATE_TEMP_MOBILITY_PROJECT = 'CREATE_TEMP_MOBILITY_PROJECT'
export const CREATE_TEMP_HISTORICAL_PROJECT = 'CREATE_TEMP_HISTORICAL_PROJECT'
